var Constants = require('./constants');

/**
 * Helper methods 
 */
module.exports = {

	/**
	 * Ajax post method 
	 */
	ajaxPost: function(serviceUri, data, caller, params) {

		var cfg = {
			url: serviceUri,
			dataType: 'json',
			data:  JSON.stringify(data),
			contentType: 'application/json; charset=utf-8',
			cache: false,
			beforeSend: function() {
				if(caller && caller.beforeAjax) caller.beforeAjax();
			}
		};

		$.extend(cfg, params);

		return $.post(cfg)
			.fail(function() {
				console.info('calling ' + serviceUri + ' failed.');
			})
			.always(function() {
				if(caller && caller.afterAjax) caller.afterAjax();
			});
	},

	/**
	 * detect IE browser
	 */
	isIE: function() {
		var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		if (isNaN(msie)) {
			msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		}
		return !isNaN(msie);
	},

	/**
	 * initialize every page
	 */
	initPage: function(conf) {		

		var self = this;

		if(typeof params === 'undefined') params = {};

		$.extend(params, Constants);
		$.extend(params, conf);

		$.extend(self, {
			ctxPath: params.ctxPath
		});

		var modules = params.modules;

		for(var key in modules) {
			var module = modules[key];
			if($.isFunction(module.init)) {
				module.init(params);
			}
		}
	},

	on: function(evtName, handler) {
		$(document).on(evtName, handler);
	},

	trigger: function(evtName, args) {
		$(document).trigger(evtName, args);
	},

	printDiv: function(windowId, w, h, fn) {// function to print the DIV element.
	    var DocumentContainer = document.getElementById(windowId);
	    var top = ($(window).height() - h)/2;
	    var left = ($(window).width() - w)/2; 
	    var WindowObject = window.open("", "PrintWindow",
	    			"width=" + w + ",height=" + w + ", top=" + top + ",left=" + left + ", toolbars=no,scrollbars=yes,status=no,resizable=yes");
	    WindowObject.document.writeln(DocumentContainer.innerHTML);

	    WindowObject.onload = function() {
	    	if(fn) {
		    	fn(WindowObject);
	    	}

	    	setTimeout(function() {
	    		WindowObject.print();
	    		WindowObject.close();
	    	}, 300);
		};

		WindowObject.document.close();
	    WindowObject.focus();
	},
	
	/**
	 * formats a product number.
	 * E.g. 202-467 -> 0202467
	 */
	formatPN: function(pn) {
		pn = pn.replace('-', '');

		while( 7 - pn.length > 0) {
			pn = '0' + pn;
		}

		return pn;
	},

	redirect: function(url) {
		this.getWindow().location.href = url; 
	},

	/**
	 * for mock purpose
	 */
	getWindow: function() {
		return window;
	},
	
	buildUrl: function(uri) {
		var self = this;

		return self.ctxPath + uri;
	},	

	/**
	* Calls `callback` once when `jQueryEl` is scrolled into view
	*/
	onVisibleOnce: function (jQueryEl, callback) {
		if (jQueryEl.length === 0) {
			return;
		}

		var self = this;
	    var scrollHandler = function () {
	        if (self.isCurrentlyVisible(jQueryEl)) {
	            $(document).off('scroll', scrollHandler);
	            callback();
	        }
	    }
	    $(document).scroll(scrollHandler);
	},

	/**
	* Returns `true` if `jQueryEl` is fully displayed within the viewport
	*/
	isCurrentlyVisible: function(jQueryEl) {
	    var boundingClientRect = jQueryEl[0].getBoundingClientRect();
	    var elTop = boundingClientRect.top;
	    var elBottom = boundingClientRect.bottom;

	    return (elTop >= 0) && (elBottom <= window.innerHeight);
	}
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/commons/helper.js
// module id = 3
// module chunks = 2 4 6 7